<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_phn_num_hrs"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >RECORDS SECTION PHONE NUMBER/HOURS OF OPERATION
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <div class="mt-6 pa-4" style="color: black">
            General Records Line: <a href="tel:7753342155">775-334-2155</a> x 0
            <br />
            Public Records Request Line:
            <a href="tel:77565746395">775-657-4639</a><br />
            Hours of Operation: Monday through Friday 8:00 am to 5:00 pm
          </div>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style scoped>
.bcs-expansion-content {
  color: black;
}
a {
  color: blue;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_phn_num_hrs",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
